<template>
  <div class="content">
    <van-nav-bar @click-left="onClickLeft" @click-right="goBand">
      <template #left>
        <img style="width: 2.66667vw;height: 5.33333vw;display: inline-block;" :src="require('../../assets/'+appTheme+'/right_icon2.png')" alt="">
      </template>
      <template #right>
        <div>银行卡</div>
      </template>
    </van-nav-bar>
    <div class="wallet-box">
      <img class="bag-bg" :src="require('../../assets/'+appTheme+'/bag_bg.png')" alt="" />
      <div class="card-box">
        <img class="bag-ka" :src="require('../../assets/'+appTheme+'/bag_ka.png')" alt="" />
        <div class="card-number">{{userInfo.wallet_id}}</div>
      </div>

    </div>
    <div class="balance-box">
      <span class="balance-hint">我的余额</span>
      <div class="balance-num"> <span class="balance-des">￥</span>{{userInfo.balance}}</div>
    </div>
    <div class="btn-list">
      <div class="btn new-btn" @click="goRecharge">立即充值</div>
      <div class="btn zs-btn" @click="goCode">中山通充值</div>
      <!--    <a style="display: block;background: #3c8ee5;" href="https://weixin.zsyjjkw.com/wechat/wx_hcn-auth.html" class="btn zs-btn">惠康中山</a>-->
      <div class="btn zs-btn" @click="goWithdraw" style="background: #EBEBEB;color: #55BB3A;">提现</div>
      <div style="text-align: center;color: #444444;margin-bottom: 2.66667vw;" @click="goDes">支付明细 ></div>
      <!--    <div class="btn btn-des" @click="goDes">支付明细</div>-->
    </div>
    <img class="logo-w" :src="require('../../assets/'+appTheme+'/logow.png')" alt="" />
    <!--  <img class="logo-w" :src="require('../../assets/'+appTheme+'/q_bao.jpg')" src="../../assets/q_bao.jpg" alt="" />-->
    <div style="height: 5.33333vw;"></div>
  </div>
</template>

<script>
export default {
  name: "wallet",
  data() {
    return {
      appTheme:this.$store.state.appTheme,
      userInfo: ''
    }
  },
  created() {
    this.getUser()
  },
  methods:{
    async getUser () {
      const res = await this.$Http.getInfo()
      if (res.code == 200){
        const info = res.data;
        this.userInfo = info;
        // console.log('res',res)
        this.$store.commit('setUserInfo', info)
      } else {
        this.$router.push('/');
      }
    },
    goBand(){
      this.$router.push({path: 'myCard'})
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    onClickRight() {
      this.$router.push({path:'/cart'})
    },
    goDes(){
      this.$router.push({path:'/billList'})
    },
    goRecharge(){
      this.$router.push({path:'/recharge'})
    },
    goWithdraw(){
      // this.$toast('暂未开放，敬请期待')
      this.$router.push({path:'/withdrawDeposit'})
    },
    goCode(){
      // 获取存储的token的值  有的话 赋值 isLogin 为true 否则 false
      const terminalToken = localStorage.getItem('terminalToken')
      var accountOpenState = localStorage.getItem('accountOpenState')
      console.log('terminalToken', terminalToken)
      if (terminalToken != null){ // 非等于空
        var tokenInfo = JSON.parse(terminalToken)
        // 获取当前时间
        let nows = new Date().getTime();
        console.log('new',nows);

        if (nows - tokenInfo.startTime > tokenInfo.expires) {
          console.log('时间到期')
          localStorage.removeItem('terminalToken');
          localStorage.removeItem('accountOpenState');
          this.$router.push('/consumerLogin');
        } else { // 没到时间
          var TokenInfo = JSON.parse(terminalToken)
          var stateInfo = JSON.parse(accountOpenState)
          console.log('没到时间 ')
          var str= 'https://jpzs.itos.cn/Wechat/Member/index.html'
          var result = Base64.encode(str);
          console.log(result)
          var url = 'https://m.bte.group/jump/terminalToken/'+TokenInfo.value+'/accountOpenState/'+ stateInfo.value+'/returnUrl/'+result
          // console.log(url)
          window.location.href = url
        }
      } else {
        this.$router.push('/consumerLogin');
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.van-hairline--bottom::after {
  border-bottom-width: 0;
}
.van-nav-bar {
  background: #FDD80D;color: #333333;font-weight: bold;font-size: 30px;
}
.van-nav-bar .van-icon {
  color: #333333;
}
.bag-bg{
  width: 100%;height: auto;display: block;
}
.card-box{
  width: 600px;height: auto;margin: -240px auto 0;position: relative;
  .bag-ka{
    width: 600px;height: auto;display: block;
  }
  .card-number{
    position: absolute;right: 15px;width: 80%;bottom: 12px;text-align: right;padding: 20px 20px;color: #000000;z-index: 2;
  }
}

.balance-box{
  text-align: center;font-size: 24px;padding-top: 30px;padding-bottom: 20px;
  .balance-num{
    font-size: 64px;font-weight: bold;margin-top: 36px;
    color: #282828;
    span{
      font-size: 55px;
    }
  }
}
.btn-list{
  //padding: 0 68px;
  .btn{
    width: 614px;border-radius: 50px;font-size: 32px;font-weight: bold;padding: 25px 0;margin: 30px auto;text-align: center;
  }
  .new-btn{
    background: #FDD80D;color: #282828;
  }
  .zs-btn{
    color: #FFFFFF;background: #55BB3A;
  }
  .btn-des{
    background: #FFFFFF;
    border: 2px solid #FDD80D;
  }
}
.logo-w{
  width: 699px;height: auto;display: block;
}
</style>
